import { getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.configurationDetails.map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>(child)=>({
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.configurationType}`),
            body: getLocalizedString(child.description, intl.locale),
            originalPrice: child.productPrice,
            price: child.totalPaid
        })
;

export { mapBundleChildLineItems };
//# sourceMappingURL=map-bundle-child-line-items.js.map
